module.exports = __webpack_public_path__ + "img/para-2.cd28f44d.jpg";